import { render } from "./TabContextMenu.vue?vue&type=template&id=5d43507f&scoped=true"
import script from "./TabContextMenu.vue?vue&type=script&lang=js"
export * from "./TabContextMenu.vue?vue&type=script&lang=js"

import "./TabContextMenu.vue?vue&type=style&index=0&id=5d43507f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d43507f"]])

export default __exports__